import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { useScroll, useMotionValueEvent } from "framer-motion";
import { Toaster } from "sonner";
import "@/App.css";
import { scrollState, mouseState } from "@/lib/scrollStore";
import { scrolleZu } from "@/lib/scroll";
import CustomCursor from "@/components/CustomCursor";
import Experience from "@/components/Experience";
import DemoSite from "@/pages/DemoSite";
import { Impressum, Datenschutz } from "@/pages/Legal";

function ScrollManager() {
  const { pathname, hash } = useLocation();
  useEffect(() => {
    if (!hash) scrolleZu(0, { immediate: true });
  }, [pathname, hash]);
  return null;
}

function App() {
  const { scrollYProgress } = useScroll();

  useMotionValueEvent(scrollYProgress, "change", (v) => {
    scrollState.progress = v;
  });

  useEffect(() => {
    // "Bewegung reduzieren" ist eine Systemeinstellung, die Menschen setzen,
    // denen von Bewegungseffekten schwindelig oder übel wird. Das entkoppelte
    // Scrollen ist dabei der unangenehmste Teil, weil die Seite dem Finger
    // nicht mehr folgt - deshalb bleibt es dann aus und der Browser scrollt
    // wie gewohnt. Die Sprungziele im Menü funktionieren weiterhin, sie
    // greifen über window.__lenis?. und fallen sauber auf scrollIntoView
    // zurück, wenn es kein Lenis gibt.
    const wenigerBewegung = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (wenigerBewegung) return undefined;

    const lenis = new Lenis({ lerp: 0.08, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (t) => {
      lenis.raf(t);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    const onMove = (e) => {
      mouseState.x = (e.clientX / window.innerWidth) * 2 - 1;
      mouseState.y = (e.clientY / window.innerHeight) * 2 - 1;
    };
    window.addEventListener("mousemove", onMove);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      window.removeEventListener("mousemove", onMove);
    };
  }, []);

  return (
    <div className="App relative bg-[#050505] text-[#F5F5F0] antialiased">
      <BrowserRouter>
        <ScrollManager />
        <CustomCursor />
        <Routes>
          <Route path="/" element={<Experience />} />
          <Route path="/projekt/:slug" element={<DemoSite />} />
          <Route path="/impressum" element={<Impressum />} />
          <Route path="/datenschutz" element={<Datenschutz />} />
        </Routes>
        <Toaster theme="dark" position="bottom-center" />
      </BrowserRouter>
    </div>
  );
}

export default App;
